<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='房间管理' label2="修改房间" url="/system/room/list"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">房间名：</label>
            <div class="col-xl-3">
              <el-form-item prop="roomname" :rules="{required: true, message: '房间名不能为空', trigger: 'blur'}">
                <el-input v-model="form.roomname" placeholder="请输入房间名"></el-input>
              </el-form-item>
            </div>
            <label class="col-xl-2 col-form-label">可入住人数：</label>
            <div class="col-xl-3">
              <el-form-item prop="peoplenum" :rules="{required: true, message: '可入住人数不能为空', trigger: 'blur'}">
                <el-input v-model="form.peoplenum" placeholder="请输入可入住人数"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12 m--align-center">
                  <SaveButton :url='saveUrl' back="/system/room/list"></SaveButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TeachEdit',
    data() {
      return {
        form: {
          id:'',
          roomname: '',
          peoplenum: '',
          token: ''
        },
        saveUrl: this.$utils.Url.zpgl + '/api/APIRoom/Update'
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.id = this.$route.params.id
      // 获取数据字典信息
      var args = {
        id: this.form.id,
        token: this.form.token
      }
      this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIRoom/Info', args, function(data, model) {
        model.roomname = data.Data.RoomName
        model.peoplenum = data.Data.PeopleNum
      }, null, null, this.form)
    }
  }
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }

  .el-select {
    width: 100%;
  }
</style>

<style scoped="scoped">
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
</style>
